import React, { useState } from 'react';
import { ButtonGroup, Button, Typography } from '@material-ui/core';

const AddContactScreen = ({ setActiveTab, entityName, FormComponent }) => {
  const [buttonSelection, setButtonSelection] = useState(null);

  const handleClick = (e) => {
    setButtonSelection(e.target.textContent);
  }

  return (
    <>
      {
        !buttonSelection &&
        <div style={{ textAlign: 'center', paddingBottom: 24 }}>
          <br />
          <Typography variant="h3">{entityName} will belong to:</Typography>
          <br />
          <br />
          <ButtonGroup size="large" color="secondary" variant="contained">
            <Button onClick={handleClick}>Organization</Button>
            <Button onClick={handleClick}>Contractor</Button>
          </ButtonGroup>
        </div>
      }
      {
        buttonSelection && <FormComponent CRUDType="INSERT" callback={() => { setActiveTab("Assigned") }} type={buttonSelection} />
      }
    </>
  )
}

export default AddContactScreen;